<div class="dialog-header">
  <h2 mat-dialog-title>{{ 'addConclusionVolumeDialog.title' | translate }}</h2>
  <button mat-icon-button (click)="close()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <form class="form-content">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'addConclusionVolumeDialog.supplierName' | translate }}</mat-label>
      <input matInput [(ngModel)]="applicantName" name="applicantName" required>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'addConclusionVolumeDialog.quotaYear' | translate }}</mat-label>
      <input matInput type="number" [(ngModel)]="quotaYear" name="quotaYear" required>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'addConclusionVolumeDialog.meatType' | translate }}</mat-label>
      <mat-select [(ngModel)]="selectedMeatType" name="meatType" required>
        @for (meatType of meatTypes(); track meatType.id) {
          <mat-option [value]="meatType">{{ getMeatTypeName(meatType) }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'addConclusionVolumeDialog.distributedVolume' | translate }}</mat-label>
      <input matInput type="number" [(ngModel)]="distributedVolume" name="distributedVolume" min="0.001" step="0.001" required>
      <mat-hint>{{ 'addConclusionVolumeDialog.volumeHint' | translate }}</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'addConclusionVolumeDialog.deliveredVolume' | translate }}</mat-label>
      <input matInput type="number" [(ngModel)]="deliveredVolume" name="deliveredVolume" min="0.001" step="0.001" required>
      <mat-hint>{{ 'addConclusionVolumeDialog.volumeHint' | translate }}</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'addConclusionVolumeDialog.pin' | translate }}</mat-label>
      <input matInput [ngModel]="personIdnp" name="personIdnp"
             inputmode="numeric" maxlength="14"
             (input)="onNumericInput($event, 'personIdnp')"
             (keydown)="onKeyDown($event)">
    </mat-form-field>
    @if (fieldErrors()['personIdnp']) {
      <div class="field-error">{{ fieldErrors()['personIdnp'] }}</div>
    }

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'addConclusionVolumeDialog.organizationInn' | translate }}</mat-label>
      <input matInput [ngModel]="organizationInn" name="organizationInn"
             inputmode="numeric" maxlength="14"
             (input)="onNumericInput($event, 'organizationInn')"
             (keydown)="onKeyDown($event)">
    </mat-form-field>
    @if (fieldErrors()['organizationInn']) {
      <div class="field-error">{{ fieldErrors()['organizationInn'] }}</div>
    }
  </form>

  @if (errorMessage()) {
    <div class="error-message">{{ errorMessage() }}</div>
  }
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="close()">{{ 'addConclusionVolumeDialog.cancel' | translate }}</button>
  <button mat-raised-button color="primary"
          (click)="submit()"
          [disabled]="!isFormValid() || loading()">
    @if (loading()) {
      <mat-spinner diameter="20"></mat-spinner>
    } @else {
      {{ 'addConclusionVolumeDialog.signAndSave' | translate }}
    }
  </button>
</mat-dialog-actions>
